import { render, staticRenderFns } from "./HighlightPunctuation.vue?vue&type=template&id=47b0340c&scoped=true&lang=html&"
import script from "./HighlightPunctuation.vue?vue&type=script&lang=js&"
export * from "./HighlightPunctuation.vue?vue&type=script&lang=js&"
import style0 from "./HighlightPunctuation.vue?vue&type=style&index=0&id=47b0340c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0340c",
  null
  
)

export default component.exports